import React, { useState, useEffect, useRef } from 'react';

const ManifestoSection = () => {
  const sectionRef = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const obs = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) { setVisible(true); obs.disconnect(); } },
      { threshold: 0.2 }
    );
    if (sectionRef.current) obs.observe(sectionRef.current);
    return () => obs.disconnect();
  }, []);

  const lineStyle = (delay) => ({
    fontFamily: 'Inter, sans-serif',
    fontWeight: 800,
    fontSize: 'clamp(44px, 7vw, 92px)',
    letterSpacing: '-0.03em',
    color: '#0A0A0A',
    opacity: visible ? 1 : 0,
    transform: visible ? 'translateY(0)' : 'translateY(40px)',
    transition: `opacity 700ms ease-out ${delay}ms, transform 700ms ease-out ${delay}ms`,
    willChange: 'transform',
    lineHeight: 1.05,
  });

  return (
    <section
      ref={sectionRef}
      data-testid="manifesto-section"
      style={{
        background: '#F5F5F7',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '80px 24px',
        textAlign: 'center',
      }}
    >
      <div style={lineStyle(0)}>El agua no se compra.</div>
      <div style={{ ...lineStyle(400), marginTop: '4px' }}>Se genera.</div>
      <div style={{
        fontFamily: 'Inter, sans-serif',
        fontWeight: 200,
        fontSize: '14px',
        letterSpacing: '0.14em',
        color: '#6B6B6B',
        textTransform: 'uppercase',
        marginTop: '56px',
        opacity: visible ? 1 : 0,
        transition: `opacity 600ms ease 1000ms`,
        maxWidth: '600px',
      }}>
        ETERNA ES UNA DECLARACIÓN DE INDEPENDENCIA HÍDRICA.
      </div>
    </section>
  );
};

export default ManifestoSection;
